import '@hg-akademie-ban/ban-ui-lib/fonts.css';
import { Modal, ScopedCssBaseline } from '@mui/material';
import { type ReactNode } from 'react';

type FullScreenProps = {
  readonly isFullscreen: boolean;
  readonly children: ReactNode;
};

export const FullScreen = ({ isFullscreen, children }: FullScreenProps) => {
  if (!isFullscreen) {
    return <>{children}</>;
  }

  return (
    <Modal open={isFullscreen}>
      <ScopedCssBaseline sx={{ backgroundColor: 'white', height: '100%', overflowY: 'scroll' }}>
        {children}
      </ScopedCssBaseline>
    </Modal>
  );
};
